import axios from "../utils/axios";

export const getRoleGroupDetailByID = (id) => {
    return axios.get(`/RoleGroup/GetDetailById`, { params: { id: id } });
};

export const getRoleFunctionList = () => {
    return axios.get(`/RoleFunction/GetList`);
};

export const getRoleMenuList = () => {
    return axios.get(`/RoleMenu/GetList`);
};

export const editRelations = (data) => {
    return axios.post(`/RoleGroup/EditRelations`, data);
};

export const getRoleGroupList = () => {
    return axios.get(`RoleGroup/GetList`);
};

export const addRoleGroup = (data) => {
    return axios.post(`/RoleGroup/Add`, data);
};

export const updateRoleGroup = (data) => {
    return axios.post(`/RoleGroup/Update`, data);
};

export const deleteRoleGroup = (payload) => {
    return axios.post(`/RoleGroup/Delete`, payload);
};
